import {profCollaborator} from 'constants/url';
import useDelete from '../../../components/hooks/useDelete';
import {DeletingOptions} from '../../../components/grid-dx/types';

function useDeleteProfCollaborator() {
  const deleteProfCollaborator = useDelete(profCollaborator);
  return (deletingOptions: DeletingOptions) =>
    deleteProfCollaborator(deletingOptions);
}

export default useDeleteProfCollaborator;
